// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Disable the navigator lock to avoid "lock was released because another
    // request stole it" errors when concurrent requests fire during a token
    // refresh. We don't run multi-tab auth coordination so the lock is not
    // needed; without it, refreshes serialize internally without throwing.
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});